module.exports = __webpack_public_path__ + "static/media/mark-finn.08f61706.jpg";